<mat-card appearance="outlined" class="settings-card">
  <mat-card-title>Theme Settings</mat-card-title>
  <mat-card-content class="settings-content">
    <mat-form-field appearance="outline">
      <mat-label>Facet theme mode</mat-label>
      <mat-select [(value)]="themeMode" (selectionChange)="emitConfig()">
        <mat-option value="auto">Auto (follow body)</mat-option>
        <mat-option value="light">Light</mat-option>
        <mat-option value="dark">Dark</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Theme preset</mat-label>
      <mat-select [(value)]="themePresetId" (selectionChange)="applyPreset($event.value)">
        <mat-option value="custom">Custom</mat-option>
        @for (preset of themePresets; track preset.id) {
          <mat-option [value]="preset.id">{{preset.label}}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-divider></mat-divider>

    <h3>Light overrides</h3>
    <div class="field-grid">
      @for (field of themeFields; track field.key) {
        <mat-form-field appearance="outline">
          <mat-label>{{field.label}}</mat-label>
          @if (field.isColor) {
            <input matInput type="color" [(ngModel)]="lightOverrides[field.key]" (ngModelChange)="onFieldChange()">
          } @else {
            <input matInput [(ngModel)]="lightOverrides[field.key]" (ngModelChange)="onFieldChange()"
                   [placeholder]="field.placeholder">
          }
        </mat-form-field>
      }
    </div>

    <mat-divider></mat-divider>

    <h3>Dark overrides</h3>
    <div class="field-grid">
      @for (field of themeFields; track field.key) {
        <mat-form-field appearance="outline">
          <mat-label>{{field.label}}</mat-label>
          @if (field.isColor) {
            <input matInput type="color" [(ngModel)]="darkOverrides[field.key]" (ngModelChange)="onFieldChange()">
          } @else {
            <input matInput [(ngModel)]="darkOverrides[field.key]" (ngModelChange)="onFieldChange()"
                   [placeholder]="field.placeholder">
          }
        </mat-form-field>
      }
    </div>
  </mat-card-content>
</mat-card>
